import React, {  useState ,useContext } from "react";
import { DataGrid, Modal, NGODatePicker } from "../../../common";
import { APIEndpoint } from "../../../utils/axios";
import moment from "moment";
import "../../../assets/styles/styles.scss";
import searchIcon from "../../../assets/icons/search.svg";
import viewIcon from "../../../assets/view.svg";
import editIcon from "../../../assets/edit.svg";
import { useTranslation } from "react-i18next";
import { FaLock } from "react-icons/fa";
import { FaGlobe, FaFlag } from "react-icons/fa";
import {
  formatDateByTimezone,
  updateButtonTxtStatus,
  getCultureFromLs
} from "../../../utils/commonFunctions";
import { CrewCommisionCreate } from "../../warehouse/inner-components/crew-commision-create";
import usePermissions from '../../../utils/userPermissions';
import { components } from "react-select";
import { ORDER_SALE_TYPE_LIST_DYNAMIC } from "../../../utils/configs";
import AllMultiSelect from "../../../common/AllSelectCheckbox";
import {ThemeContext} from '../../../contexts/themeContext';


const commisionViewColumns = [
  {
    field: "seqNo",
    headerName: "Sl No",
    flex: 1,
    autoHeight: true,
    suppressSizeToFit: true,
  },
  {
    field: "name",
    headerName: "Name",
    suppressSizeToFit: true,
    flex: 1,
    autoHeight: true,
  },
  {
    field: "from",
    headerName: "From",
    flex: 1,
    autoHeight: true,
    suppressSizeToFit: true,
  },
  {
    field: "to",
    headerName: "To",
    suppressSizeToFit: true,
    flex: 1,
    autoHeight: true,
  },
  {
    field: "value",
    headerName: "Value",
    suppressSizeToFit: true,
    flex: 1,
    autoHeight: true,
  },
];

const SectorsCellRenderer = ({ value }) => {
  if (value === "int") {
    return (
      <div className="orderStatus-renderer">
        <span>
          <FaGlobe color={"#70CEEA"} size={15} />&nbsp;
          International
        </span>
      </div>
    );
  } else if (value === "dom") {
    return (
      <div className="orderStatus-renderer">
        <span>
          <FaFlag color={"green"} size={15} />&nbsp;
          Domestic
        </span>
      </div>
    );
  } else {
    return <></>;
  }
};


export const getOrderSaleType = (saleTypes) => {
  if (!Array.isArray(saleTypes)) return "";

  return saleTypes
    .map((val) => {
      const match = ORDER_SALE_TYPE_LIST_DYNAMIC.find((_) => _.value === val);
      return match?.label || val;
    })
    .join(", ");
};

export const CrewCommisionRatePage = ({ sheetData }) => {
  const { t } = useTranslation();
  const [state, setState] = useState({});
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: "" });
  const [modalCustomButtons, ] = useState(null);
  const [searchKey, setSearchKey] = useState("");
  const [selectedRow, setSelectedRow] = useState([]);
  const [hasSlabChanged, setHasSlabChanged] = useState(false);
  const {themedColor} = useContext(ThemeContext);

  const { hasPermission: createCrewCommission } = usePermissions('create', 'orn:Account:ManageCrewCommissionRates');
  const { hasPermission: viewDetailsCrewCommission } = usePermissions('viewDetails', 'orn:Account:ManageCrewCommissionRates');
  const { hasPermission: saveCrewCommission } = usePermissions('save', 'orn:Account:ManageCrewCommissionRates');
  const { hasPermission: editCrewCommission } = usePermissions('edit', 'orn:Account:ManageCrewCommissionRates');
  const { hasPermission: finalizeCrewCommission } = usePermissions('finalize', 'orn:Account:ManageCrewCommissionRates');


  const handleRowSelection = (rowData) => {
    if (!Array.isArray(rowData)) return;

    const filteredRows = rowData.filter(
      (row) =>
        Array.isArray(row) &&
        row.some((cell) => {
          const val = cell?.value;
          return (
            (typeof val === "string" && val.trim() !== "") ||
            (typeof val === "number" && val !== 0)
          );
        })
    );

    setSelectedRow(filteredRows);
    setHasSlabChanged(true);
  };

  const getSlabParameterLabel = (value) => {
    const slabType = slabParameter.find((item) => item.value === value);
    return slabType ? slabType.label : value ;
  };

  const Columns = [
    {
      field: "name",
      headerName: "Name",
      resizable: true,
      minWidth: 200,
      width: 200,
      autoHeight: true,
      pinned: "left",
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "sectorType",
      headerName: "Sector Type",
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellRendererFramework: SectorsCellRenderer,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "effectiveFrom",
      headerName: "Effective From",
      valueGetter: (params) => {
        return params.data?.effectiveFrom
          ? moment(params.data?.effectiveFrom).format("DD-MM-YYYY ")
          : "";
      },
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "effectiveUntil",
      headerName: "Effective Until",
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      valueGetter: (params) => {
        return params.data?.effectiveUntil
          ? moment(params.data?.effectiveUntil).format("DD-MM-YYYY ")
          : "";
      },
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "saleTypes",
      headerName: "Sale Types",
      resizable: true,
      minWidth: 150,
      autoHeight: true,

      valueGetter: (params) => {
              return params.data ? getOrderSaleType(params.data?.saleTypes) : "";
            },
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "dependentVariable",
      headerName: "Slab Parameter",
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      valueFormatter: (params) => getSlabParameterLabel(params.value),
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "status",
      headerName: "Status",
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "createdOn",
      headerName: "Created On",
      valueGetter: params => {
            return params.data?.audit ? moment(params.data?.audit?.createdOn).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : ''},
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "createdBy",
      headerName: "Created By",
      valueGetter: (params) => params.data?.audit?.createdBy,
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "modifiedOn",
      headerName: "Last Modified On",
      valueGetter: params => {
        return params.data?.audit ? moment(params.data?.audit?.modifiedOn).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : ''},
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      field: "modifiedBy",
      headerName: "Last Modified By",
      valueGetter: (params) => params.data?.audit?.modifiedBy,
      resizable: true,
      minWidth: 150,
      autoHeight: true,
      cellStyle: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      headerName: "Actions",
      pinned: "right",
      autoResize: true,
      minWidth: 240,
      width: 255,
      flex: 1,
      resizable: false,
      suppressSizeToFit: true,
      headerClass: "actions-header",
      cellRenderer: actionSets,
      valueGetter: function (params) {
        return params;
      },
    },
  ];
  const handleAction = async (type, data) => {
    if (type === "view" || type === "finalize" || type === "edit") {
      try {
        const response = await APIEndpoint.get(
          `/incentive/crew-commission-rates/${data.id}`
        );

        if (response) {
          setState((_prev) => ({
            ..._prev,
            selected: {
              ...response,
              items: [response],
              slabs: response.slabs || [],
              action: type,
              saleType: ORDER_SALE_TYPE_LIST_DYNAMIC.filter((item) =>
                response.saleTypes.includes(item.value)
              ),
            },
          }));
        }
      } catch (error) {
        console.error("Error fetching details:", error);
      }
    }
  };

  function actionSets(props) {
    return props.data ? (
      <>
    { viewDetailsCrewCommission? <span
          title={"View"}
          className="margRight10"
          onClick={() => handleAction("view", props.data)}
        >
          <img className="aircraft-actions" alt={"view"} src={viewIcon} />
        </span>:<></>}
        {props.data.status !== "finalized" && editCrewCommission && (
        <>
          <span
            title={"Edit"}
            className="margRight10"
            onClick={() => handleAction("edit", props.data)}
          >
            <img className="aircraft-actions" alt={"edit"} src={editIcon} />
          </span>
         {finalizeCrewCommission? <span
            title={"Finalize"}
            className="margRight10 grid-LOI-stylebutton-fin-loi1"
            onClick={() => handleAction("finalize", props.data)}
          >
            <FaLock color={"#be6b58"} size={15} /> Finalize
          </span>:<></>}
        </>
        )}
      </>
    ) : (
      <></>
    );
  }
  const filterData = {
    action: 4,
    collection: "",
    filterOperation: "or",
    filters: [],
    limit: 50,
    page: 1,
    searchParam: "",
  };

  const fetchCrewCommisionRateRows = async (page = 1, perPage = 50) => {
    if(!viewDetailsCrewCommission)return;
    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;
    filterData.sort = [];
    filterData.sort.push({ field: "effectiveFrom", order: "desc" });
    if (state) {
      let filters = [];
      const filterConditions = [
        {
          condition: state.sectorType,
          filter: { sectorType: state.sectorType },
        },
        { condition: state.status, filter: { status: state.status } },
        {
          condition: state.effectiveFrom,
          filter: { effectiveFrom: formatDateByTimezone(state.effectiveFrom) },
        },
        {
          condition: state.effectiveUntil,
          filter: {
            effectiveUntil: formatDateByTimezone(state.effectiveUntil),
          },
        },
        {
          condition: state.dependentVariable,
          filter: { dependentVariable: state.dependentVariable },
        },
        {
          condition: state.targetDate,
          filter: { targetDate: state.targetDate },
        },
      ];

      filterConditions.forEach(({ condition, filter }) => {
        if (condition) {
          const existingFilterIndex = filters.findIndex((existingFilter) => {
            return Object.keys(existingFilter).every((key) =>
              filter.hasOwnProperty(key)
            );
          });

          if (existingFilterIndex !== -1) {
            const existingFilter = filters[existingFilterIndex];
            filters[existingFilterIndex] = { ...existingFilter, ...filter };
          } else {
            filters.push(filter);
          }
        }
      });
      filterData.filters = filters;
    }

    try {
      const res = await APIEndpoint.post(
        "incentive/crew-commission-rates/list",
        filterData
      );

      if (res && res.items.length) {
        return res;
      } else {
        if (page === 1) {
          return {
            items: [],
            count: 0,
          };
        }
      }
    } catch (error) {}
  };
  const statusState = [
    { id: 1, label: "Draft", value: "draft" },
    { id: 2, label: "Finalized", value: "finalized" },
  ];
  const sectorType = [
    { id: 1, label: "International", value: "int" },
    { id: 2, label: "Domestic", value: "dom" },
  ];
  const slabParameter = [
    { id: 1, label: "Total Amount", value: "totalAmount" },
    { id: 2, label: "Revenue Per Pax", value: "revenuePerPax" },
  ];

  const onSearch = (e) => {
    setSearchKey(e.target.value);
  };
  const handleStatusChange = (e) => {
    setState((_prev) => {
      return {
        ..._prev,
        status: e.target.value,
        resetDataSource: !state.resetDataSource,
      };
    });
  };
  const onDateChange = (e) => {
    setState((_prev) => {
      return {
        ..._prev,
        effectiveFrom: e.target.value,
        resetDataSource: !_prev.resetDataSource,
      };
    });
  };
  const onDateUntilChange = (e) => {
    setState((_prev) => {
      return {
        ..._prev,
        effectiveUntil: e.target.value,
        resetDataSource: !_prev.resetDataSource,
      };
    });
  };
  const onActiveChange = (e) => {
    setState((_prev) => {
      return {
        ..._prev,
        targetDate: e.target.value,
        resetDataSource: !_prev.resetDataSource,
      };
    });
  };
  const handleChangeSaleType = (e) => {
    setState((_prev) => {
      return {
        ..._prev,
        sectorType: e.target.value,
        resetDataSource: !_prev.resetDataSource,
      };
    });
  };
  const handleChangeSlabParameter = (e) => {
    setState((_prev) => {
      return {
        ..._prev,
        dependentVariable: e.target.value,
       resetDataSource: !_prev.resetDataSource,
      };
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      selected: {
        ...prevState.selected,
        [name]: value,
      },
    }));
  };

  const onClose = () => {
    setState((_prev) => {
      return { ..._prev, selected: null };
    });
    setModalFormStatusObj({ text: "" });
  };
  const handleReset = () => {

    let timerId = setTimeout(() => {
      clearTimeout(timerId);
      setState((_) => {
        return { ..._, resetDataSource:  !_.resetDataSource };
      })
      onClose();
    }, 1200)
  }
  const handleModalCancel = () => {
    setState((prev) => ({ ...prev, selected: null }));
  };
  const onAddItemHandler = () => {
    setState((_prev) => {
      return { ..._prev, selected: { action: "create" } };
    });
  };

  function handleChangeActions(selectedOptions) {
    setState((prevState) => ({
      ...prevState,
      selected: {
        ...prevState.selected,
        saleType: selectedOptions || [],
      },
    }));
  }

  const onEditSubmit = async (e, updated) => {
    try {
      const btnText = "Finalize";
      updateButtonTxtStatus(false, e, "Finalizing...", true, {
        defaultButtonText: btnText,
      });
      const body = {};

      APIEndpoint.put(
        `incentive/crew-commission-rates/${state.selected.items[0]?.id}/finalize`,
        body
      )
        .then((resp) => {
          if (resp.success) {
            updateButtonTxtStatus(true, e, btnText, false, {
              defaultButtonText: btnText,
            });
            setState((_prev) => ({
              ..._prev,
              resetDataSource: !_prev.resetDataSource,
            }));

            setModalFormStatusObj({ text: resp.message });
            handleReset()
          } else {
            updateButtonTxtStatus(false, e, "Finalize failed", false, {
              defaultButtonText: btnText,
            });
            setModalFormStatusObj({ text: resp.message });
            handleReset()
          }
        })
        .catch((error) => {
          updateButtonTxtStatus(false, e, "Finalize failed", false, {
            defaultButtonText: btnText,
          });
          let { data } = JSON.parse(error?.message);
          setModalFormStatusObj({ error: data.message });
        });
    } catch (err) {
      setModalFormStatusObj({ error: `Error: ${err.message}` });
    }
  };

  const handleCrewCommissionSubmit = async (updated, action, data) => {
    if(!saveCrewCommission)return;
    const getNumericValue = (row, id) => {
      const val = row.find(item => item.id === id)?.value;
      return (val == null || val === "") ? null : Number(val);
};

const body = {
  name: updated?.selected?.name,
  sectorType: updated?.selected?.sectorType,
  saleTypes: updated?.selected?.saleType?.map(item => item.value) || [],
  dependentVariable: updated?.selected?.dependentVariable,
  effectiveFrom: updated?.selected?.effectiveFrom,
  effectiveUntil: updated?.selected?.effectiveUntil || null,
  slabs: hasSlabChanged
    ? selectedRow.map((row, index) => ({
        name: row.find(item => item.id === "Name")?.value || "",
        index: index,
        from: getNumericValue(row, "from"),
        to: getNumericValue(row, "To"),
        value: getNumericValue(row, "Value"),
        seqNo: index + 1,
      }))
    : updated?.selected?.slabs || [],
};
    if (
      !body.name ||
      !body.sectorType ||
      !body.saleTypes ||
      !body.dependentVariable ||
      !body.effectiveFrom
    ) {
      setModalFormStatusObj({ error: "Please select all required fields(*)." });
      setTimeout(() => {
        setModalFormStatusObj({ error: "" });
      }, 2000);
      return false;
    }

    try {
      let res;

      if (action === "edit") {
        res = await APIEndpoint.put(
          `incentive/crew-commission-rates/${state.selected.items[0]?.id}`,
          body
        );
      } else if (action === "create") {
        res = await APIEndpoint.post(`incentive/crew-commission-rates`, body);
      }

      if (res) {
        setModalFormStatusObj({ text: res.message });
        handleReset()

      }
    } catch (error) {
      const errObj = JSON.parse(error?.message ?? error);

      setModalFormStatusObj({
        error:
          errObj.data?.message ||
          errObj.data?.msg ||
          "Something went wrong. Please try again.",
      });
    }
  };

  const Option = (props) => {
    return (
      <div>
        <components.Option {...props}>
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null}
          />{" "}
          <label>{props.label}</label>
        </components.Option>
      </div>
    );
  };

  const MultiValue = (props) => (
    <components.MultiValue {...props}>
      <span>{props.data.label}</span>
    </components.MultiValue>
  );

  // view and finalized details

  const renderModalContent = (selectedItem, slabs) => {
    return (
      <div className="flexCol width100">
        <div className="flexRow space-btn justifyContentFlexStart width100">
          {/* Left Side */}
          <div className="flexCol width50">
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">Name</label>
              <div>{selectedItem?.name || "NA"}</div>
            </div>
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">Sale Types</label>
              <div>
                {selectedItem?.sectorType === "int"
                  ? "International"
                  : selectedItem?.sectorType === "dom"
                  ? "Domestic"
                  : "NA"}
              </div>
            </div>
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">
                Effective From
              </label>
              <div>  { moment(selectedItem?.effectiveFrom ).format("YYYY-MM-DD") ||"NA"}</div>
            </div>
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">
                Slab Parameter
              </label>
              <div>
              {selectedItem?.dependentVariable === "totalAmount"
                  ? "Total Amount"
                  : selectedItem?.dependentVariable === "revenuePerPax"
                  ? "Revenue Per Pax"
                  : "NA"}
              </div>
            </div>
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">Slabs</label>
            </div>
          </div>

          {/* Right Side */}
          <div className="flexCol width50">
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">Sales Type</label>
              <div>{getOrderSaleType(selectedItem?.saleTypes) || "NA"}</div>
            </div>
            <div className="margBottom10">
              <label className="fontExtrabold margBottom10">
                Effective Until
              </label>
              <div>
             {selectedItem?.effectiveUntil? moment(selectedItem?.effectiveUntil ).format("YYYY-MM-DD") :"NA"}
              </div>
            </div>
          </div>
        </div>

        <DataGrid
          columnResize
          showDefaultFilters={false}
          enableGridSearch={false}
          className="full-flex"
          rowModelType="clientSide"
          columns={commisionViewColumns}
          rowData={slabs}

        />
      </div>
    );
  };

  return (
    <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>
          <div className="flexRow width100 margBot10 margTop8 justifyContentSpaceBetween">
            <div className="width100Menu justifyContentCenter flexRow">
              <div className="margLeft margBot10 margTop8  underline">
                <span>
                  <img
                    className="icon-size"
                    alt={t("filters.searchText")}
                    src={searchIcon}
                  />
                </span>
                <span>
                  <input
                    className="search"
                    onChange={onSearch}
                    type="search"
                    placeholder={t("filters.searchText")}
                    value={searchKey}
                  />
                </span>
              </div>
            </div>
            <div className="flexRow justifyContentFlexEnd ">
             {createCrewCommission? <button
                className="add-item-button m-2"
                onClick={onAddItemHandler}
              >
                + Add Rates
              </button>:null}
            </div>
          </div>
          <div className="flexRow width100 justifyContentSpaceBetween">
            <div className="flexRow width100 margBot10 margTop8 justifyContentFlexStart">
              <button className="orderStatus-div m-2">
                <>
                  <NGODatePicker
                    style={{ width: "13rem" }}
                    value={
                      state.effectiveFrom ? new Date(state.effectiveFrom) : null
                    }
                    dateFormat="dd/MM/yyy"
                    name="effectivefrom"
                    className="input-margin"
                    isClearable={true}
                    placeholder="Effective From"
                    placeholdertext={t("datePickerPlaceholder")}
                    onChange={onDateChange}
                  />
                </>
              </button>
              <button className="orderStatus-div m-2">
                <>
                  <NGODatePicker
                    style={{ width: "13rem" }}
                    value={
                      state.effectiveUntil
                        ? new Date(state.effectiveUntil)
                        : null
                    }
                    dateFormat="dd/MM/yyy"
                    name="effectiveUntil"
                    className="input-margin"
                    isClearable={true}
                    placeholder="Effective Until"
                    placeholdertext={t("datePickerPlaceholder")}
                    onChange={onDateUntilChange}
                  />
                </>
              </button>
              <button className="orderStatus-div m-2">
                <select
                  className="select-item darkBlue-bg"
                  onChange={handleStatusChange}
                  value={state.status}
                  id="orderStatusId"
                >
                  <option key={""} value={""}>
                    Select Status
                  </option>
                  {statusState.map((_) => {
                    return (
                      <option key={_.key} value={_.value}>
                        {_.label}
                      </option>
                    );
                  })}
                </select>
              </button>
              <button className="orderStatus-div m-2">
                <select
                  className="select-item darkBlue-bg"
                  onChange={handleChangeSaleType}
                  value={state.saleTypes}
                  id="orderStatusId"
                >
                  <option key={""} value={""}>
                    Sector Type
                  </option>
                  {sectorType.map((_) => {
                    return (
                      <option key={_.key} value={_.value}>
                        {_.label}
                      </option>
                    );
                  })}
                </select>
              </button>
              <button className="orderStatus-div m-2">
                <select
                  className="select-item darkBlue-bg"
                  onChange={handleChangeSlabParameter}
                  value={state.slabParameter}
                  id="orderStatusId"
                >
                  <option key={""} value={""}>
                    Slab Parameter
                  </option>
                  {slabParameter.map((_) => {
                    return (
                      <option key={_.key} value={_.value}>
                        {_.label}
                      </option>
                    );
                  })}
                </select>
              </button>
              <button className="orderStatus-div m-2">
                <>
                  <NGODatePicker
                    style={{ width: "13rem" }}
                    value={
                      state.targetDate
                        ? new Date(state.targetDate)
                        : null
                    }
                    dateFormat="dd/MM/yyy"
                    name="targetDate"
                    className="input-margin"
                    isClearable={true}
                    placeholder="Active Date"
                    placeholdertext={t("datePickerPlaceholder")}
                    onChange={onActiveChange}
                  />
                </>
              </button>
            </div>

          </div>
          <DataGrid
            className="full-flex"
            columns={Columns}
            showDefaultFilters={false}
            searchKey={searchKey}
            getRows={fetchCrewCommisionRateRows}
            rowSelection="multiple"
            onAddItemHandler={() => onAddItemHandler()}
            columnResize={true}
            resetDataSource={state.resetDataSource}
          />
        </>
      }

      {state &&
        state.selected &&
        ((state.selected.action === "edit"  && editCrewCommission) ||
         ( state.selected.action === "create" && createCrewCommission) ) && (
          <Modal
            className="cash-deposit-summary"
            key={state.selected.action}
            title={
              state.selected?.action === "edit"
                ? `Edit Crew Commission Rate - ${state.selected?.items?.[0]?.name || ""}`
                : "Create Crew Commission Rates"
            }

            onClose={onClose}
            onSubmit={() =>
              handleCrewCommissionSubmit(state, state.selected.action)
            }
            modalFormStatusObj={modalFormStatusObj}
            buttonLabel="Save"
          >
            <div className="flexCol width100">
              <div className="flexRow space-btn justifyContentFlexStart width100">
                <div className="flexCol">
                  <div className="flexCol justifyContentSpaceEvenly ">
                    <div className=" dialog__container_item input-container">
                      <div className="dialog__description">
                        <label className={`fontRegular req`}>Name</label>

                        <input
                          id="name"
                          type={"text"}
                          name="name"
                          placeholder={"Name"}
                          value={state?.selected?.name}
                          style={{ width: "17rem" }}
                          onChange={handleInputChange}
                          className="edit-input-galley-aircraft edit-input-create-ac"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flexCol justifyContentSpaceEvenly ">
                    <div className=" dialog__container_item input-container">
                      <div className="dialog__description">
                        <label className="req">Sectors</label>

                        <select
                          className="select-input-galley1"
                          name="sectorType"
                          value={state?.selected?.sectorType || ""}
                          onChange={handleInputChange}
                        >
                          <option value="">Select Sector</option>
                          <option value="dom">Domestic</option>
                          <option value="int">International</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="flexCol justifyContentSpaceEvenly ">
                    <div className=" dialog__container_item input-container">
                      <div className="dialog__description">
                        <label className={`fontRegular req`}>
                          Effective Date
                        </label>
                        <div className={`dialog__description`}>
                          <NGODatePicker
                            value={
                              state?.selected?.effectiveFrom
                                ? new Date(state?.selected?.effectiveFrom)
                                : null
                            }
                            style={{ width: "17rem" }}
                            name="effectiveFrom"
                            isclearable={false}
                            minDate={new Date()}
                            placeholder={t("effectiveDate")}
                            placeholdertext={t("datePickerPlaceholder")}
                            onChange={handleInputChange}
                            className="custom-datepicker"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flexCol margLeft">
                  <div className="flexCol justifyContentSpaceEvenly ">
                    <div className=" dialog__container_item input-container">
                      <div className="dialog__description">
                        <label className={`fontRegular req`}>Sales Type</label>
                        <button className="saleType-div m-2">
                          <AllMultiSelect
                            options={ORDER_SALE_TYPE_LIST_DYNAMIC}
                            defaultValue={[]}
                            isMulti
                            styles={{
                              input: (provided) => ({
                                ...provided,
                                color: "#fff",
                              }),
                              control: (defaultStyles) => ({
                                ...defaultStyles,
                                backgroundColor: themedColor.background,
                                width: "17rem",
                                boxShadow: "none",
                              }),
                              multiValue: (provided) => ({
                                ...provided,
                              }),
                              multiValueLabel: (provided, state) => ({
                                ...provided,
                                width: "auto",
                                whiteSpace: "nowrap",
                                overflow: "visible",
                                title: state.data.label,
                              }),
                              menu: (provided) => ({
                                ...provided,
                                backgroundColor: themedColor.background,
                                width: "auto",
                                minWidth: "25rem",
                                maxWidth: "30rem",
                              }),
                              option: (provided, state) => ({
                                ...provided,
                                textAlign: "left",
                                backgroundColor: state.isFocused
                                  ? themedColor.hover
                                  : "transparent",
                                color: state.isFocused ? "#fff" : "#fff",
                                cursor: "pointer",
                                "&:hover": {
                                  backgroundColor: themedColor.hover,
                                  color: "#fff",
                                },
                              }),
                            }}
                            isSearchable
                            isClearable
                            components={{ Option, MultiValue }}
                            onChange={handleChangeActions}
                            allowSelectAll={true}
                            value={state.selected?.saleType || []}
                            name="saleTypes"
                            placeholder={`Select SaleType`}
                          />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flexCol justifyContentSpaceEvenly ">
                    <div className=" dialog__container_item input-container">
                      <div className="dialog__description">
                        <label className="fontRegular req">
                          Slab Parameter
                        </label>
                        <div className={`dialog__description`}>
                          <select
                            className="select-input-galley1"
                            name="dependentVariable"
                            value={state?.selected?.dependentVariable || ""}
                            onChange={handleInputChange}
                          >
                            <option value="">Select slab parameter</option>
                            <option value="totalAmount">Total Amount</option>
                            <option value="revenuePerPax">Revenue Per Pax</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <CrewCommisionCreate
                sheetData={sheetData}
                onRowSelect={handleRowSelection}
                slabs={state?.selected?.slabs}
              />
            </div>
          </Modal>)
        }

      {state && state.selected && state.selected.action === "view" && viewDetailsCrewCommission && (
        <Modal
          className="cash-deposit-summary"
          key={state.selected.action}
          title={`Crew Commission Rates - ${
            state.selected.items[0]?.name || ""
          }`}
          onClose={onClose}
          onSubmit={handleModalCancel}
        >
          {renderModalContent(state.selected.items[0], state.selected.slabs)}
        </Modal>
      )}
      {state && state.selected && state.selected.action === "finalize" && finalizeCrewCommission && (
        <Modal
          className="cash-deposit-summary"
          key={state.selected.action}
          title={`Finalize Crew Commission Rates- ${state.selected.items[0]?.name || ""}`}
          onClose={onClose}
          onSubmit={onEditSubmit}
          modalFormStatusObj={modalFormStatusObj}
          modalCustomButtons={modalCustomButtons}
          buttonLabel="Finalize"
        >
          <div className="alert alert-warning">
            {t("pages.pagesContent.crewCommision.FinalizeWarning")}
          </div>
          {renderModalContent(state.selected.items[0], state.selected.slabs)}
        </Modal>
      )}
    </div>
  );
};
